import { HttpInterceptorFn } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { timeout } from "rxjs";
import { TIMEOUT_MS } from "../../constants/timeout";

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    req.url.startsWith(environment.baseUrl + "/energyExport/") ||
    req.url.startsWith(environment.baseUrl + "/media/") ||
    (!req.url.startsWith(environment.baseUrl) && !req.url.startsWith(environment.baseUrlV2))
  ) {
    return next(req);
  } else {
    return next(req).pipe(timeout(TIMEOUT_MS));
  }
};
